import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getLocalToken, getApplicationId } from "../../api/common";

const PublicRoute = ({ component: Component, ...rest }) => {
  // Add your own authentication on the below line.

  return (
    <Route
      {...rest}
      render={(props) =>
        !getLocalToken() && !getApplicationId() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

export default PublicRoute;
